import { ActivityIndicator } from 'react-native'

import { colors } from '@zet/design-system'
import CreditCardOutlined from '@zet/design-system/svg/CreditCardOutlined'
import ErrorOutlined from '@zet/design-system/svg/ErrorOutlined'
import MoneyBagOutlined from '@zet/design-system/svg/MoneyBagOutlined'
import PhoneFilled from '@zet/design-system/svg/PhoneFilled'
import Tick from '@zet/design-system/svg/Tick'
import Whatsapp from '@zet/design-system/svg/Whatsapp'
import { i18n } from '@zet/localization'

import {
  CustomerChat,
  ProductCatalogue,
  ProductsOutlined,
  ProfessionalWebsite,
} from '../../assets/svgs'
import { SubdomainAvailability } from '../api/types'
import { handleCallPress, handleWhatsappPress } from './index'

export const topFeaturesItems = [
  {
    icon: <ProfessionalWebsite width={48} height={48} />,
    header: 'professional',
  },
  {
    icon: <ProductCatalogue width={48} height={48} />,
    header: 'easyTo',
  },
  {
    icon: <CustomerChat width={48} height={48} />,
    header: 'keepYour',
  },
]

export function handleSubdomainIcon(
  searchedSubdomain: string,
  isLoading: boolean,
  data: SubdomainAvailability,
  errorMessage: string
) {
  if (!searchedSubdomain) return <></>
  if (isLoading) return <ActivityIndicator size={'small'} className="ml-2" />
  else if (data?.isAvailable && !errorMessage)
    return <Tick color={colors.success[100]} className="ml-2" />
  else return <ErrorOutlined color={colors.error[100]} className="ml-2" />
}
export const enum AgentWebsite {
  AGENT_WEBSITE = 'agent-website',
}
export const addedFromAgentWebsiteFilter = {
  label: 'agentWebsite.addedFrom',
  value: [1, 2, 3, 4, 6, 8, 9, 10, 11, 12, 13], //TODO - Need to discuss with backend.
  name: 'added from website',
  customerSource: [AgentWebsite.AGENT_WEBSITE],
}
export const agentWebsiteFaqsVideos = {
  banner:
    'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/Thumbnails/My+Website.png',
  videoId: '_kk6DDfBzuM',
}
export const enum InterestedCategory {
  LOAN = 'LOANS',
  CREDIT_CARD = 'CC',
  OTHER_CATEGORY = 'OTHERS',
}
export function handleEnquiryTag(interestedCategory: string) {
  switch (interestedCategory) {
    case InterestedCategory.LOAN:
      return {
        icon: <MoneyBagOutlined color={colors.primary[150]} size={16} />,
        text: i18n.t('agentWebsiteInterestedIn', {
          category: 'Loans',
        }),
      }
    case InterestedCategory?.CREDIT_CARD:
      return {
        icon: <CreditCardOutlined color={colors.primary[150]} size={16} />,
        text: i18n.t('agentWebsiteInterestedIn', {
          category: 'Credit Card',
        }),
      }
    case InterestedCategory?.OTHER_CATEGORY:
      return {
        icon: <ProductsOutlined color={colors.primary[150]} />,
        text: i18n.t('agentWebsiteInterestedIn', {
          category: 'Other Products',
        }),
      }
    default:
      return {
        icon: <ProductsOutlined color={colors.primary[150]} />,
        text: i18n.t('agentWebsiteInterestedIn', {
          category: InterestedCategory.OTHER_CATEGORY,
        }),
      }
  }
}

export function handleWhatsAppAndCallIcon(phoneNumber: string | undefined) {
  const icons = [
    {
      icon: <PhoneFilled color={colors.primary[100]} />,
      borderColor: 'border-primary-30',
      onPress: () => handleCallPress(phoneNumber),
    },
    {
      icon: <Whatsapp color={colors.success[100]} />,
      borderColor: 'border-success-50',
      onPress: () => handleWhatsappPress(phoneNumber),
    },
  ]
  return icons
}
